import { create } from "zustand";

type SystemPopProps = {
    title?: string;
    content?: string;
    rightButton?: string;
    onRightClick?: () => void;
    type?: string;
};

interface SystemPopState {
    isVisible: boolean;
    title?: string;
    content?: string;
    rightButton?: string;
    onRightClick?: () => void;
    type?: string;
    showPop: (config: Omit<SystemPopProps, "onRightClick"> & { onRightClick: () => void }) => void;
    hidePop: () => void;
}

export const useSystemPopStore = create<SystemPopState>(set => ({
    isVisible: false,
    title: undefined,
    content: undefined,
    rightButton: undefined,
    onRightClick: undefined,
    type: undefined,
    showPop: ({ title, content, rightButton, onRightClick, type }) =>
        set({ isVisible: true, title, content, rightButton, onRightClick, type }),
    hidePop: () => set({ isVisible: false, title: undefined, content: undefined, rightButton: undefined, onRightClick: undefined }),
}));
